import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CompareFuncService {
  constructor() {}

  /**
   * Compares two values for sorting.
   *
   * @param a First value
   * @param b Second value
   * @returns Negative if a < b, positive if a > b, 0 if equal
   *
   * Sorting behavior:
   * - String dates (YYYYMMDD or YYYYMMDD-HHMMSS): Descending order (newest to oldest)
   * - Other strings: Ascending order (alphabetically)
   * - Non-strings (assumed numbers): Ascending order
   */
  compareValues(a, b) {
    if (typeof a === 'string' && typeof b === 'string') {
      const regExp1 = /^\d{4}\d{2}\d{2}-\d{2}\d{2}\d{2}$/;
      const regExp2 = /^\d{4}\d{2}\d{2}$/;
      if (
        (regExp1.test(a) && regExp1.test(b)) ||
        (regExp2.test(a) && regExp2.test(b)) ||
        (regExp1.test(a) && regExp2.test(b)) ||
        (regExp2.test(a) && regExp1.test(b))
      ) {
        return b.localeCompare(a);
      }
      return a.localeCompare(b);
    }
    return a - b;
  }
}
